import { Button, makeStyles } from '@material-ui/core';
import MUIDataTable from 'mui-datatables';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { FaEdit } from 'react-icons/fa';
import { FilterToolbar } from '../../components/FilterToolbar';
import { FilterChip } from './FilterChip';

const useStyles = makeStyles((theme) => ({
  formSpan: {
    marginTop: '10px',
    fontFamily: 'Roboto',
    fontSize: '15px',
    color: '#888',
    textAlign: 'center',
    // width: '80%',
  },
}));

const questionTypes = {
  evaluation: 'Evaluación',
  workshop: 'Taller',
  open: 'Abierta',
};

export function useQuestions(page, limit, filters) {
  const [questions, setQuestions] = useState([]);

  const filtersToSend = useMemo(() => {
    const filtersToSend = {};

    Object.keys(filters).forEach((key) => {
      if (filters[key]) {
        filtersToSend[key] = filters[key];
      }
    });

    return filtersToSend;
  }, [filters]);

  useEffect(() => {
    fetch(
      `https://api.edicionesmilenio.com/api/questions/filter?page=${
        page + 1
      }&limit=${limit}`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(filtersToSend),
      }
    )
      .then((response) => response.json())
      .then((data) => {
        let q = data?.data?.docs?.map((question) => ({
          _id: question?._id,
          serie: question?.serie?.name,
          grade: question?.grade?.name,
          period: question?.period,
          questionType: questionTypes[question?.questionType],
          activityType: question?.activityType,
          question: question?.question,
        }));

        setQuestions({ ...data?.data, docs: q });
      })
      .catch((error) => {
        console.error(error);
      });
  }, [filtersToSend, limit, page]);
  return { questions, setQuestions };
}

export function Question() {
  const defaultFilters = {
    serie: '',
    grade: '',
    period: '',
    questionType: '',
    activityType: '',
    question: '',
  };

  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [sortOrder, setSortOrder] = useState({});
  const [searchValue, setSearchValue] = useState('');
  const [openFilter, setOpenFilter] = useState(false);
  const [filters, setFilters] = useState(defaultFilters);

  const { questions, setQuestions } = useQuestions(page, limit, filters);

  const sort = useCallback(
    (changedColumn, direction) => {
      const sortFunction = (a, b) => {
        if (a[changedColumn] < b[changedColumn]) {
          return direction === 'asc' ? -1 : 1;
        }
        if (a[changedColumn] > b[changedColumn]) {
          return direction === 'asc' ? 1 : -1;
        }
        return 0;
      };

      const sortedState = [...questions.docs];

      sortedState?.sort(sortFunction);

      JSON.stringify(sortedState) !== JSON.stringify(questions.docs) &&
        setQuestions((prevState) => ({ ...prevState, docs: sortedState }));
    },
    [questions.docs, setQuestions]
  );

  const search = async () => {
    const response = searchValue
      ? await fetch(
          `https://api.edicionesmilenio.com/api/questions-search/${searchValue}?page=${
            page + 1
          }&limit=${limit}`
        )
      : await fetch(
          `https://api.edicionesmilenio.com/api/questions?page=${
            page + 1
          }&limit=${limit}`
        );

    const data = await response.json();

    let q = data?.data?.docs?.map((question) => ({
      _id: question?._id,
      serie: question?.serie?.name,
      grade: question?.grade?.name,
      period: question?.period,
      questionType: questionTypes[question?.questionType],
      activityType: question?.activityType,
      question: question?.question,
    }));

    setQuestions({ ...data?.data, docs: q });
  };

  useEffect(() => {
    if (questions && Object.keys(sortOrder).length) {
      sort(Object.keys(sortOrder)[0], Object.values(sortOrder)[0]);
    }
  }, [sortOrder, questions, sort]);

  const classes = useStyles();

  const columns = [
    {
      name: 'serie',
      label: 'Serie',
    },
    {
      name: 'grade',
      label: 'Grado',
    },
    {
      name: 'period',
      label: 'Periodo',
    },
    {
      name: 'questionType',
      label: 'Tipo',
    },
    {
      name: 'activityType',
      label: 'Actividad',
    },
    {
      name: 'question',
      label: 'Pregunta',
    },
    {
      name: 'actions',
      label: 'Herramientas',
      options: {
        filter: false,
        customBodyRenderLite: (dataIndex, rowIndex) => {
          return (
            <a
              href={`/admin/questions-update/${questions?.docs[dataIndex]?._id}`}
              target="_blank"
              rel="noreferrer"
            >
              <Button color="primary">
                <FaEdit />
              </Button>
            </a>
          );
        },
      },
    },
  ];

  const handleDelete = async (rowsDeleted) => {
    const confirm = window.confirm(
      '¿Está seguro que desea eliminar las preguntas seleccionadas?'
    );
    if (confirm) {
      rowsDeleted?.data?.forEach(async (row) => {
        await fetch(
          `https://api.edicionesmilenio.com/api/questions/${
            questions?.docs[row?.dataIndex]?._id
          }`,
          {
            method: 'DELETE',
          }
        );
      });
    }
  };

  return (
    <div
      style={{
        width: '100%',
        paddingLeft: '20px',
        paddingRight: '20px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
      }}
    >
      <p className={classes.formSpan}>
        Estimado administrador, desde esta sección podrás visualizar la lista de
        preguntas creadas en la plataforma, desde esta sección podrá gestionar
        cada una de ellas, ten mucha precaución de eliminar alguna de ellas, si
        ya cuenta contenido asociado, este proceso no se puede recuperar.
      </p>
      <MUIDataTable
        title={'Listado de preguntas'}
        data={questions?.docs || []}
        columns={columns}
        options={{
          serverSide: true,
          count: questions?.totalDocs || 0,
          page,
          rowsPerPage: limit,
          customToolbar: () => {
            return (
              <FilterToolbar
                openFilter={openFilter}
                setOpenFilter={setOpenFilter}
              >
                <FilterChip
                  setOpenFilter={setOpenFilter}
                  filters={filters}
                  setFilters={setFilters}
                  defaultFilters={defaultFilters}
                />
              </FilterToolbar>
            );
          },
          customSearchRender: (_, handleSearch, hideSearch) => {
            return (
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '20px',
                  padding: '20px',
                }}
              >
                <input
                  type="text"
                  value={searchValue || ''}
                  onChange={(e) => {
                    setSearchValue(e.target.value);
                    handleSearch(e.target.value);
                  }}
                  placeholder={'Buscar'}
                  style={{
                    fontSize: '16px',
                    padding: '5px 5px 5px 5px',
                    border: '1px solid rgba(0,0,0,0.2)',
                    borderRadius: '4px',
                    width: '100%',
                    marginBottom: '20px',
                  }}
                />
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    search();
                    hideSearch();
                  }}
                  style={{
                    width: 'max-content',
                    marginBottom: '20px',
                    padding: '10px',
                    border: '1px solid rgba(0,0,0,0.2)',
                    borderRadius: '4px',
                    fontSize: '14px',
                  }}
                >
                  Buscar
                </Button>
              </div>
            );
          },
          onColumnSortChange: (changedColumn, direction) =>
            setSortOrder({ [changedColumn]: direction }),
          textLabels: {
            body: {
              noMatch: 'Lo sentimos, no se encontraron registros coincidentes',
              toolTip: 'Ordenar',
              columnHeaderTooltip: (column) => `Ordenar por ${column.label}`,
            },
            pagination: {
              next: 'Siguiente',
              previous: 'Anterior',
              rowsPerPage: 'Filas por página:',
              displayRows: 'de',
            },
            toolbar: {
              search: 'Buscar',
              downloadCsv: 'Descargar CSV',
              print: 'Imprimir',
              viewColumns: 'Ver columnas',
              filterTable: 'Filtrar tabla',
            },
            filter: {
              all: 'Todos',
              title: 'FILTROS',
              reset: 'REINICIAR',
            },
            viewColumns: {
              title: 'Mostrar columnas',
              titleAria: 'Mostrar/Ocultar columnas de tabla',
            },
            selectedRows: {
              text: 'fila(s) seleccionadas',
              delete: 'Eliminar',
              deleteAria: 'Eliminar filas seleccionadas',
            },
          },
          filter: false,
          onTableChange: (action, tableState) => {
            switch (action) {
              case 'changePage':
                setPage(tableState.page);
                break;
              case 'changeRowsPerPage':
                setLimit(tableState.rowsPerPage);
                break;
              default:
                break;
            }
          },
          onRowsDelete: (rowsDeleted) => {
            handleDelete(rowsDeleted);
          },
        }}
      />
    </div>
  );
}
